import { ShopifyProduct, ShopifyProductType } from '@/lib/shopify';
import { CartItemProperty, ITEM_ORIGINS } from '@/core/constants';
import { TypeStartingInstallment } from '@/lib/api/subscriptionManager/types';

export function buildPrimaryProductProperties(
  shopifyProduct: ShopifyProduct,
  origin: ITEM_ORIGINS,
  subscriptionPlanStartingInstallments?: TypeStartingInstallment[] | null,
  subscriptionPlanAnchor?: string,
) {
  const isCoursePack =
    shopifyProduct?.productType === ShopifyProductType.COURSE;

  const isSkillSet =
    shopifyProduct?.productType === ShopifyProductType.SKILL_SET;

  const isERCSubscriptionProduct =
    shopifyProduct?.productType === ShopifyProductType.EARLY_READER_CLUB;

  const targetStartingInstallment = subscriptionPlanStartingInstallments?.find(
    (installment) =>
      shopifyProduct.variants.some(
        (variant) => variant.sku === installment.sku,
      ),
  );

  return [
    {
      key: CartItemProperty.QuantityLimitedToOne,
      value: String(isCoursePack || isERCSubscriptionProduct),
    },
    {
      key: CartItemProperty.IsCoursePack,
      value: String(isCoursePack),
    },
    {
      key: CartItemProperty.IsSkillSet,
      value: String(isSkillSet),
    },
    {
      key: CartItemProperty.ItemOrigin,
      value: origin,
    },
    ...(subscriptionPlanAnchor && targetStartingInstallment
      ? [
          {
            key: CartItemProperty.SubscriptionPlanSettings,
            value: formatSubscriptionPlanProperties(
              subscriptionPlanAnchor,
              targetStartingInstallment,
              origin,
            ),
          },
        ]
      : []),
  ];
}

function formatSubscriptionPlanProperties(
  subscriptionPlanAnchor: string,
  startingInstallment: TypeStartingInstallment,
  origin: string,
) {
  return JSON.stringify({
    plan_anchor: subscriptionPlanAnchor,
    plan_installment_id: startingInstallment.id,
    sku: startingInstallment.sku,
    item_origin: origin,
  });
}

export function buildAddonProductProperties(shopifyProduct: ShopifyProduct) {
  return [
    // this attribute supports removing addon products from the cart when the primary product is removed from the cart
    {
      key: CartItemProperty.LinkedProductHandle,
      value: shopifyProduct?.handle,
    },
    {
      key: CartItemProperty.ItemOrigin,
      value: ITEM_ORIGINS.PRODUCT_PAGE,
    },
  ];
}
